import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Books", path: "/books" },
  { label: "Insights", path: "/insights" },
  { label: "Speaking", path: "/speaking" },
  { label: "Reform Intelligence", path: "/reform-intelligence" },
  { label: "VALOR", path: "/valor" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-heading font-black text-lg tracking-tight text-[#1B2A4A]">
            DR. BEN MAGEE
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="nav-desktop-links">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`px-3 py-2 text-sm font-medium transition-colors rounded-sm ${
                pathname === link.path
                  ? "text-[#C9A84C] bg-[#F5EDD6]"
                  : "text-[#1B2A4A] hover:text-[#C9A84C]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contact">
            <Button
              data-testid="nav-contact-cta"
              className="bg-[#C9A84C] text-[#1B2A4A] hover:bg-[#b59744] hover:text-white font-semibold rounded-sm px-6"
            >
              Contact
            </Button>
          </Link>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="lg:hidden">
            <Button variant="ghost" size="icon" data-testid="nav-mobile-menu">
              <Menu className="h-5 w-5 text-[#1B2A4A]" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72 bg-white p-0">
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between p-4 border-b">
                <span className="font-heading font-black text-[#1B2A4A]">DR. BEN MAGEE</span>
              </div>
              <nav className="flex flex-col p-4 gap-1">
                {NAV_LINKS.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setOpen(false)}
                    data-testid={`nav-mobile-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className={`px-3 py-3 text-sm font-medium rounded-sm transition-colors ${
                      pathname === link.path
                        ? "text-[#C9A84C] bg-[#F5EDD6]"
                        : "text-[#1B2A4A] hover:bg-[#E8EDF5]"
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
                <Link to="/contact" onClick={() => setOpen(false)}>
                  <Button
                    data-testid="nav-mobile-contact-cta"
                    className="w-full mt-4 bg-[#C9A84C] text-[#1B2A4A] hover:bg-[#b59744] hover:text-white font-semibold rounded-sm"
                  >
                    Contact
                  </Button>
                </Link>
              </nav>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
